import React, { useState } from 'react'
import { DialogSpin } from 'components'
import { Button } from '@mui/material'
import { useBurnUnbalanceMutation } from 'features'
import { useDispatch } from 'react-redux'
import { successSnack, errorSnack } from 'features/snack-bar/snackSlice'
import { useOutletContext } from 'react-router-dom'

/**
 *
 * @param {*} _props
 * @returns
 */
export default function SetUnbalanceBurnDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    rowData = {},
  } = _props
  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()
  const { activeRow } = useOutletContext()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }

  const [revertTrans] = useBurnUnbalanceMutation()

  function handleSubmit(data) {
    const mutation = revertTrans({
      unbalanceid: activeRow.unbalanceid,
      bctransaction: rowData,
    })
    mutation
      .then((response) => {
        if (response.data) {
          dispatch(
            successSnack({
              message: 'Activos quemados correctamente',
            })
          )
          closeDialog()
        } else {
          if (response.error.data) {
            let message = ''
            switch (response.error.data.message) {
              case 'unbalance_not_found':
                message = 'No se encontró el desbalance'
                break
              case 'mov_not_user':
                message = 'El movimiento no cumple con los requerimientos'
                break
              default:
                message = 'Error al quemar los activos'
                break
            }
            dispatch(
              errorSnack({
                message: message,
              })
            )
          }
        }
      })
      .catch((error) => {
        dispatch(errorSnack({ message: 'Error al quemar los activos' }))
      })
  }

  const message = `¿Está seguro que desea quemar ${rowData.row.ammount}?`

  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <DialogSpin
          open={open}
          handleClose={closeDialog}
          primaryButtonText="Quemar" //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={`Quemar activo`} // 'Dialog title'
          message={message}
          onSubmit={handleSubmit} // Form submit action
        />
      )}
    </>
  )
}
